// removed by extract-text-webpack-plugin
module.exports = {"container":"CancelDescription__container___km9Tg"};